import { TicketStatusOptions } from '../../../../shared/const'

/*
 * Kurzbeschreibung je Status fuer die Zeile unter dem Funnel. Bewusst
 * definitorisch gehalten - was der Status bedeutet, nicht welche Uebergaenge
 * erlaubt sind. Der Ablauf gehoert fachlich JAA; hier stehen nur Bedeutungen.
 *
 * Seit 22.08.2026 **ein** Satz fuer alle Arten: Dieselbe Kette, dieselben
 * Woerter, gleich ob Fehler, Wunsch, Entscheidung oder Sonstiges.
 * TODO(JAA): Wortlaut bestaetigen lassen.
 */
export const STATUS_HINT = {
	NEW: 'Eingegangen und noch nicht gesichtet.',
	CLARIFICATION: 'Rückfragen offen, bevor es weitergeht.',
	READY: 'Geklärt und angenommen, wartet auf Bearbeitung.',
	IN_DEVELOPMENT: 'Jemand bearbeitet sie gerade.',
	REVIEW: 'Erledigt, wartet auf Bestätigung.',
	ACCEPTED: 'Bestätigt und abgeschlossen.',
	REJECTED: 'Nicht weiterverfolgt.'
}

/** Auswahl und Kurzbeschreibungen der Statuskette. */
export const funnelStufen = () => ({ options: TicketStatusOptions, hints: STATUS_HINT })
